<template>
  <div>
    <bar-chart :xdata="xdata" :series="series" :rotate="30"  :type="'hospital'" />
  </div>
</template>
<script>
// 柱状图
import BarChart from '@/components/layouts/BarChart';
export default {
  computed: {
    xdata() {
      let arr = [];
      this.hospitalArr.map((item) => {
        arr.push(item.hospitalName);
      });
      return arr;
    },
    series() {
      let data = [];
      this.hospitalArr.map((item) => {
        data.push({
          name: item.hospitalName,
          value: item.hospitalNum,
          //  datas:[item.insuredNum,item.totalAmount]
        });
      });
      return [
        {
          type: 'bar',
          stack: 'vistors',
          barWidth: '60%',
          data: data,
          barMaxWidth: 30,
          animationDuration: 2000,
        },
      ];
    },
  },
  props: {
    hospitalArr: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    BarChart,
  },
};
</script>